import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const EMPTY = { owner_name: "", phone: "", dog_name: "", dog_breed: "", dog_age: "", notes: "" };

export function ClientForm({ initial, onSubmit, submitLabel = "Guardar", onCancel }) {
  const [form, setForm] = useState({ ...EMPTY, ...(initial || {}) });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.owner_name.trim()) return;
    setSaving(true);
    await onSubmit(form);
    setSaving(false);
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="client-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label htmlFor="owner_name">Nome do dono *</Label>
          <Input id="owner_name" value={form.owner_name} onChange={set("owner_name")} required data-testid="field-owner-name" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="phone">Telefone</Label>
          <Input id="phone" value={form.phone} onChange={set("phone")} data-testid="field-phone" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="dog_name">Nome do cão</Label>
          <Input id="dog_name" value={form.dog_name} onChange={set("dog_name")} data-testid="field-dog-name" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="dog_breed">Raça</Label>
          <Input id="dog_breed" value={form.dog_breed} onChange={set("dog_breed")} data-testid="field-dog-breed" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="dog_age">Idade</Label>
          <Input id="dog_age" value={form.dog_age} onChange={set("dog_age")} placeholder="ex: 3 anos" data-testid="field-dog-age" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="notes">Notas (temperamento, alergias, corte preferido)</Label>
        <Textarea id="notes" value={form.notes} onChange={set("notes")} rows={3} data-testid="field-notes" />
      </div>
      <div className="flex justify-end gap-2 pt-2">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel} data-testid="form-cancel">
            Cancelar
          </Button>
        )}
        <Button type="submit" disabled={saving} className="bg-[#E20074] hover:bg-[#c00063] text-white" data-testid="form-submit">
          {saving ? "A guardar…" : submitLabel}
        </Button>
      </div>
    </form>
  );
}
